import { inject } from '@angular/core'
import { Router, CanActivateFn } from '@angular/router'
import { SessionService } from 'superlikers-microsites-api'
import { map } from 'rxjs'

export const pendingRequirementsGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService)
  const router = inject(Router)

  return sessionService.checkRequirements().pipe(
    map(result => {
      const { allowed } = result

      if (!allowed) return true

      router.navigate(['/home'])
      return false
    })
  )
}
